import React from "react";
import {Cell, Row} from "@tanstack/react-table";
import {CheckCircleFill} from "react-bootstrap-icons";
import moment from "moment";
import {dateAsTimeString} from "fearless-common";
import {ErrorBoundary} from "fearless-common-ui";
import {defaultDateTimeFormat} from "../../../utils/date";

/**
 * Rendering function for a few types of column values.
 * The components are used for the Column.Cell property of react-table columns.
 */
const CellRender = {
  Bool: function BoolRender<D extends object>({ cell }: { cell: Cell<D, any> }) {
    const value = cell.getValue();
    if (value === true) return <CheckCircleFill className="text-success" />;
    const d = moment(value);
    if (value && d.isValid()) return <CheckCircleFill className="text-success" />;
    return <>No</>;
  },
  /**
   * Show an array as comma-separated values
   */
  CSV: function ArrayRender<D extends object>({ cell }: { cell: Cell<D, any>; }) {
    const value = cell.getValue();
    return <ErrorBoundary>{Array.isArray(value) ? value.join(', ') : '-'}</ErrorBoundary>
  },
  Length: function ArrayRender<D extends object>({ cell }: { cell: Cell<D, any>; }) {
    const value = cell.getValue();
    return <>{Array.isArray(value) ? value.length : '-'}</>
  },
  Date: function DateRender<D extends object>({ cell }: { cell: Cell<D, any>; }){
    const value = cell.getValue();
    const d = moment(value);
    return <>{value && d.isValid() ? dateAsTimeString(value) : '-'}</>;
  },
  DateTime: function DateTimeRender<D extends object>({ cell }: { cell: Cell<D, any>; }) {
    const value = cell.getValue();
    const d = moment(value);
    return <>{value && d.isValid() ? d.format(defaultDateTimeFormat) : '-'}</>;
  },
  FullName: function FullNameRender<D extends object>({ row, getValue }: { row: Row<D>; getValue: () => any }) {
    const value = getValue();
    // @ts-ignore
    if (value && typeof value === 'object' && 'first_name' in value) {
      return <>{`${value?.last_name}, ${value?.first_name}`}</>
    }
    // @ts-ignore
    return <>{`${row.original?.last_name}, ${row.original?.first_name}`}</>;
  },
};

export default CellRender;
